import { render, staticRenderFns } from "./CoEventTicketCheckout.vue?vue&type=template&id=3a71c504&scoped=true&"
import script from "./CoEventTicketCheckout.vue?vue&type=script&lang=ts&"
export * from "./CoEventTicketCheckout.vue?vue&type=script&lang=ts&"
import style0 from "./CoEventTicketCheckout.vue?vue&type=style&index=0&id=3a71c504&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a71c504",
  null
  
)

export default component.exports